/*
 * <umm-cart-carousel>
 *
 * Initializes the Swiper used by the cart-drawer / cart-notification "you may
 * also like" carousel (snippets/umm-cart-carousel.liquid).
 *
 * Implemented as a custom element rather than an inline script because the cart
 * drawer's markup is replaced wholesale (innerHTML) by cart-drawer.js /
 * cart-notification.js on every cart update — injected <script> tags do not
 * re-execute, but a custom element's connectedCallback fires again when the
 * fresh markup is inserted, so the carousel re-initializes itself.
 *
 * Requires Swiper, which theme.liquid loads globally (swiper-bundle.min.js).
 */
if (!customElements.get('umm-cart-carousel')) {
  customElements.define('umm-cart-carousel', class UmmCartCarousel extends HTMLElement {
    connectedCallback() {
      // Guard against double-init if connectedCallback fires more than once.
      if (this.swiper) return;
      if (typeof Swiper === 'undefined') return;

      const container = this.querySelector('.umm-cc-swiper');
      if (!container) return;

      this.swiper = new Swiper(container, {
        slidesPerView: 2.2,
        spaceBetween: 12,
        watchOverflow: true,
        navigation: {
          nextEl: this.querySelector('[class*="umm-cc-next-"]'),
          prevEl: this.querySelector('[class*="umm-cc-prev-"]'),
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 14,
          },
        },
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  });
}
